export default __webpack_public_path__ + "static/media/attachedUSers.2fa8a218.svg";